module.exports = __webpack_public_path__ + "static/search-poster-cab5b96033b861b2ae1360631e4b7d4b.png";